// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "code[class*=language-],pre[class*=language-]{font-size:.9em}", ""]);
// Exports
module.exports = exports;
